import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getManageSolicitationThunk = createAsyncThunk(
    `GetManageSolicitationSlicer/getManageSolicitationThunk`,
    async (solicitationId, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const { data } = await conciergeApiClient.get(
            `Redemption/get-by-id/${solicitationId}`,
            {
                headers,
            });
        return data;
    }
);

const solicitationInitialValue = {
    details: {},
    actions: [],
    approvedQuotation: null,
    status: null,
    orders: [],
    solicitationItemsDetails: {},
    quotations: [],
    actionHistory: {},
    addresses: {}
}

const initialState = {
    dataGetManageSolicitation: solicitationInitialValue,
    loadingGetManageSolicitation: false,
    errorGetManageSolicitation: false,
};

const GetManageSolicitationSlicer = createSlice({
    name: 'GetManageSolicitation',
    initialState,
    reducers: {
        resetDataGetManageSolicitation: (state) => {
            state.dataGetManageSolicitation = solicitationInitialValue;
            state.loadingGetManageSolicitation = false;
            state.errorGetManageSolicitation = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getManageSolicitationThunk.pending, (state) => {
            state.dataGetManageSolicitation = solicitationInitialValue;
            state.loadingGetManageSolicitation = true;
            state.errorGetManageSolicitation = false;
        });
        builder.addCase(getManageSolicitationThunk.fulfilled, (state, action) => {            
            state.dataGetManageSolicitation = action.payload;
            state.loadingGetManageSolicitation = false;
            state.errorGetManageSolicitation = false;
        });
        builder.addCase(getManageSolicitationThunk.rejected, (state) => {
            state.dataGetManageSolicitation = solicitationInitialValue;
            state.loadingGetManageSolicitation = false;
            state.errorGetManageSolicitation = true;
        });
    },
});

export const { resetDataGetManageSolicitation } = GetManageSolicitationSlicer.actions;
export default GetManageSolicitationSlicer.reducer;